import Categories from '@/api/categories/categories.js'

const categories = new Categories()

const categoriesModule = {
  namespaced: true,
  state: {
    items: [],
    categories: [],
    lookups: [],
    load: false,
  },
  getters: {
    items: state => state.items,
    load: state => state.load,
    getCategories: state => state.categories,
    lookups(state) {
      return state.lookups
    },
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_LOAD(state, load) {
      state.load = load
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups
    },
  },
  actions: {
    list({ commit }, query) {
      commit('SET_LOAD', true)
      return new Promise((resolve, reject) => {
        categories
          .list(query)
          .then(response => {
            commit('SET_ITEMS', response)
            commit('SET_CATEGORIES', response)
            commit('SET_LOAD', false)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    put({ commit, dispatch }, query) {
      return new Promise((resolve, reject) => {
        categories
          .put(query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        categories
          .update(payload)
          .then(response => {
            commit('SET_CATEGORIES', response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    get({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        categories
          .get(id)
          .then(response => {
            console.log('Category fetched successfully:', response)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        categories
          .delete(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    categoryLookups({ commit }) {
      return new Promise((resolve, reject) => {
        categories
          .lookups()
          .then(response => {
            commit('SET_LOOKUPS', response)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
  },
}

export default categoriesModule
